import { getCookieDialogLocalStorage } from '../store/localstorage/actions/getCookieDialogLocalStorage';

export const isCookiePerformanceAllowed = (): boolean => {
    const localStorage = getCookieDialogLocalStorage();
    return localStorage.newPerformanceAllowedValue !== undefined ? localStorage.newPerformanceAllowedValue : localStorage.isPerformanceAllowed;
};
